(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-media-badge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('trust-ribbon')) {
    class TrustRibbon extends HTMLElement {
      connectedCallback() {
        this.ribbon = this.querySelector('.pdpb');
        if (!this.ribbon) return;
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-pdpb-dot]'));
        this.dialog = this.querySelector('[data-pdpb-dialog]');
        this.tab = this.querySelector('[data-pdpb-expand]');
        this.inner = this.querySelector('[data-pdpb-inner]');
        this.row = this.querySelector('.pdpb__row');
        this.fill = this.querySelector('.pdpb__progress-fill');
        this.live = this.querySelector('[data-pdpb-live]');
        this.count = Number(this.dataset.count) || 1;
        this.interval = Number(this.dataset.interval) || 5000;
        this.remaining = this.interval;
        this.index = 0;
        this.timer = null;
        this.hovered = false;
        this.visible = true;
        this.userControlled = false;
        this.dismissed = false;
        this.away = false;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.designMode = Boolean(window.Shopify && window.Shopify.designMode);
        this.storageKey = 'pdpb-dismissed';

        this.onVisibility = () => this.sync();
        this.onMedia = () => this.sync();
        this.addEventListener('click', (e) => this.onClick(e));
        this.ribbon.addEventListener('pointerenter', (e) => {
          if (this.dataset.pauseHover === 'false' || e.pointerType !== 'mouse') return;
          this.hovered = true;
          this.sync();
        });
        this.ribbon.addEventListener('pointerleave', () => { this.hovered = false; this.sync(); });
        this.ribbon.addEventListener('focusin', () => { this.focused = true; this.sync(); });
        this.ribbon.addEventListener('focusout', () => { this.focused = false; this.sync(); });
        document.addEventListener('visibilitychange', this.onVisibility);
        this.reduced.addEventListener('change', this.onMedia);
        this.mobile.addEventListener('change', this.onMedia);
        this.dialog && this.dialog.addEventListener('close', () => this.sync());

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => {
            this.visible = entries[0].isIntersecting;
            this.sync();
          });
          this.io.observe(this.ribbon);
        }

        this.watchGallery();
        if (!this.designMode && this.isDismissed()) {
          this.ribbon.classList.add('is-instant');
          this.setDismissed(true, false);
          requestAnimationFrame(() => requestAnimationFrame(() => this.ribbon.classList.remove('is-instant')));
        }
        this.sync();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        document.removeEventListener('visibilitychange', this.onVisibility);
        this.reduced && this.reduced.removeEventListener('change', this.onMedia);
        this.mobile && this.mobile.removeEventListener('change', this.onMedia);
        this.io && this.io.disconnect();
        this.mo && this.mo.disconnect();
        this.mediaIo && this.mediaIo.disconnect();
      }

      canRotate() {
        if (this.count < 2 || this.dataset.autoplay !== 'true' || this.userControlled) return false;
        if (this.reduced.matches) return false;
        if (this.mobile.matches && this.dataset.mobileRotate === 'static') return false;
        return true;
      }

      shouldRun() {
        return this.canRotate() && this.visible && !document.hidden && !this.hovered && !this.focused
          && !this.dismissed && !this.away && !(this.dialog && this.dialog.open);
      }

      /* One place decides whether the timer runs; progress bar pauses with it. */
      sync() {
        this.ribbon.classList.toggle('is-rotating', this.canRotate());
        if (this.shouldRun()) {
          this.ribbon.classList.remove('is-paused');
          if (!this.timer) {
            this.startedAt = Date.now();
            this.timer = setTimeout(() => { this.timer = null; this.go((this.index + 1) % this.count); }, this.remaining);
          }
        } else {
          if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
            this.remaining = Math.max(300, this.remaining - (Date.now() - this.startedAt));
          }
          this.ribbon.classList.add('is-paused');
        }
      }

      go(n, byUser) {
        if (n === this.index || n < 0 || n >= this.count) return;
        const prev = this.index;
        this.index = n;
        this.slides.forEach((el) => {
          const i = Number(el.dataset.slide);
          el.setAttribute('aria-hidden', i === n ? 'false' : 'true');
          el.classList.remove('is-leaving');
          el.classList.toggle('is-active', i === n);
          if (i === prev) {
            el.classList.add('is-leaving');
            setTimeout(() => el.classList.remove('is-leaving'), 600);
          }
        });
        this.dots.forEach((d) => {
          const on = Number(d.dataset.pdpbDot) === n;
          d.classList.toggle('is-active', on);
          on ? d.setAttribute('aria-current', 'true') : d.removeAttribute('aria-current');
        });
        if (byUser) {
          this.userControlled = true;
          if (this.live) this.live.setAttribute('aria-live', 'polite');
        }
        clearTimeout(this.timer);
        this.timer = null;
        this.remaining = this.interval;
        if (this.fill) { this.fill.style.animation = 'none'; void this.fill.offsetWidth; this.fill.style.animation = ''; }
        this.sync();
      }

      onClick(e) {
        const dot = e.target.closest('[data-pdpb-dot]');
        if (dot) { this.go(Number(dot.dataset.pdpbDot), true); return; }

        if (e.target.closest('[data-pdpb-dismiss]')) { this.setDismissed(true, true); return; }
        if (e.target.closest('[data-pdpb-expand]')) { this.setDismissed(false, true); return; }
        if (e.target.closest('[data-pdpb-dialog-close]')) { this.dialog.close(); return; }
        if (e.target === this.dialog) { this.dialog.close(); return; }

        const link = e.target.closest('[data-pdpb-link]');
        if (!link) return;
        this.userControlled = true;
        const type = link.dataset.pdpbLink;
        if (type === 'scroll') {
          e.preventDefault();
          this.scrollToTarget(link.dataset.target);
        } else if (type === 'modal') {
          this.openProof(link.dataset.index, link);
        }
        this.sync();
      }

      /* Section handle, #id or data-anchor -> element. Handles Shopify's "template--123__handle" section ids. */
      resolve(key) {
        const k = String(key || '').replace(/[^\w-]/g, '');
        if (!k) return null;
        return document.getElementById(k)
          || document.querySelector('[data-anchor="' + k + '"]')
          || document.querySelector('.shopify-section[id$="__' + k + '"]')
          || document.querySelector('.shopify-section[id*="' + k + '"]');
      }

      /* Open whatever is hiding the target: accordion <details>, ARIA tab panels. */
      reveal(el) {
        let node = el;
        while (node && node !== document.body) {
          if (node.tagName === 'DETAILS' && !node.open) node.open = true;
          if (node.getAttribute && node.getAttribute('role') === 'tabpanel' && node.hasAttribute('hidden')) {
            const id = node.getAttribute('aria-labelledby');
            const tab = id && document.getElementById(id);
            if (tab) tab.click();
          }
          node = node.parentElement;
        }
        if (el.tagName === 'DETAILS' && !el.open) el.open = true;
      }

      scrollToTarget(key) {
        const el = this.resolve(key);
        if (!el) { console.warn('[trust-ribbon] no section found for "' + key + '"'); return; }
        this.reveal(el);
        const root = getComputedStyle(document.documentElement);
        const header = parseFloat(root.getPropertyValue('--sticky-header-height')) || 0;
        const extra = Number(this.dataset.scrollOffset) || 0;
        const top = el.getBoundingClientRect().top + window.scrollY - header - extra;
        window.scrollTo({ top: Math.max(0, top), behavior: this.reduced.matches ? 'auto' : 'smooth' });
        if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
        el.focus({ preventScroll: true });
        el.classList.remove('pdpb-flash');
        void el.offsetWidth;
        el.classList.add('pdpb-flash');
        setTimeout(() => el.classList.remove('pdpb-flash'), 2000);
      }

      openProof(idx, trigger) {
        const tpl = this.querySelector('template[data-proof="' + idx + '"]');
        if (!tpl || !this.dialog) return;
        const body = this.dialog.querySelector('[data-pdpb-dialog-body]');
        body.replaceChildren(tpl.content.cloneNode(true));
        this.dialog.setAttribute('aria-label', tpl.dataset.title || '');
        this.dialog.showModal();
      }

      isDismissed() {
        const mode = this.dataset.remember;
        if (mode === 'none') return false;
        try {
          if (mode === 'session') return sessionStorage.getItem(this.storageKey) === '1';
          const raw = localStorage.getItem(this.storageKey);
          if (!raw) return false;
          const days = Number(this.dataset.rememberDays) || 7;
          if (Date.now() - Number(raw) > days * 864e5) { localStorage.removeItem(this.storageKey); return false; }
          return true;
        } catch (err) { return false; }
      }

      /* The ribbon belongs to the FIRST image. On any other image it steps aside (it would sit on top of the
         photo and be hard to read); coming back to image 1 brings it back. Closing it yourself always wins. */
      watchGallery() {
        const wrap = this.closest('.product__gallery-container') || this.parentElement;
        const media = wrap && wrap.querySelector('media-gallery');
        if (!media) return;
        const current = (el) => el.getAttribute('aria-current') === 'true' || el.getAttribute('aria-selected') === 'true'
          || el.classList.contains('is-active') || el.classList.contains('is-selected');
        const update = () => {
          const thumbs = Array.from(media.querySelectorAll('.product__thumbnail'));
          if (thumbs.length < 2) return;
          // Thumbnails hidden = grid layout where every image is on screen at once, nothing to step aside for.
          this.setAway(thumbs[0].offsetParent !== null && !current(thumbs[0]));
        };
        this.mo = new MutationObserver(update);
        this.mo.observe(media, { subtree: true, attributes: true, attributeFilter: ['aria-current', 'aria-selected', 'class'] });
        update();

        const first = media.querySelector('.product__media-list > *');
        if (first && !media.querySelector('.product__thumbnail') && 'IntersectionObserver' in window) {
          this.mediaIo = new IntersectionObserver((entries) => this.setAway(entries[0].intersectionRatio < 0.5), { threshold: [0, 0.5, 1] });
          this.mediaIo.observe(first);
        }
      }

      setAway(value) {
        if (value === this.away) return;
        this.away = value;
        this.ribbon.classList.toggle('is-away', value);
        this.ribbon.inert = value;
        this.sync();
      }

      /* Close = fold into a small tab (or vanish when the tab is switched off). Reopen = unfold. */
      setDismissed(value, persist) {
        this.dismissed = value;
        clearTimeout(this.goneTimer);
        clearTimeout(this.unpinTimer);
        /* Pin the row's width while it folds so the copy never re-wraps mid-animation (that was the stutter). */
        if (this.row) {
          if (value) {
            const w = this.row.getBoundingClientRect().width;
            if (w > 0) this.row.style.width = w + 'px';
          } else {
            this.unpinTimer = setTimeout(() => this.row.style.removeProperty('width'), 650);
          }
        }
        this.ribbon.classList.toggle('is-collapsed', value);
        if (this.inner) this.inner.inert = value;
        if (this.tab) {
          this.tab.tabIndex = value ? 0 : -1;
          if (value && persist) setTimeout(() => this.tab.focus({ preventScroll: true }), 520);
        } else if (value) {
          this.goneTimer = setTimeout(() => this.ribbon.classList.add('is-gone'), 560);
        }
        if (!value) {
          this.ribbon.classList.remove('is-gone');
          if (persist && this.dataset.restoreFocus !== 'false') {
            const first = this.ribbon.querySelector('.pdpb__link, .pdpb__close');
            first && setTimeout(() => first.focus({ preventScroll: true }), 520);
          }
        }
        if (persist && !this.designMode) {
          const mode = this.dataset.remember;
          try {
            if (value && mode === 'session') sessionStorage.setItem(this.storageKey, '1');
            else if (value && mode === 'days') localStorage.setItem(this.storageKey, String(Date.now()));
            else if (!value) { sessionStorage.removeItem(this.storageKey); localStorage.removeItem(this.storageKey); }
          } catch (err) {}
        }
        this.sync();
      }
    }
    customElements.define('trust-ribbon', TrustRibbon);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-review-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('review-strip')) {
    class ReviewStrip extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-rvs-viewport]');
        if (!this.viewport) return;
        this.prev = this.querySelector('[data-rvs-prev]');
        this.next = this.querySelector('[data-rvs-next]');
        this.dots = Array.from(this.querySelectorAll('.rvs__dot'));
        this.cards = Array.from(this.querySelectorAll('.rvs__card'));
        this.onScroll = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); }); };
        this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
        this.prev && this.prev.addEventListener('click', () => this.step(-1));
        this.next && this.next.addEventListener('click', () => this.step(1));
        this.viewport.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); this.step(document.dir === 'rtl' || this.closest('[dir=rtl]') ? -1 : 1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.step(document.dir === 'rtl' || this.closest('[dir=rtl]') ? 1 : -1); }
        });
        this.dialog = this.querySelector('[data-rvs-dialog]');
        this.addEventListener('click', (e) => {
          const z = e.target.closest('[data-rvs-zoom]');
          if (z && this.dialog) {
            this.dialog.querySelector('[data-rvs-dialog-img]').src = z.dataset.src;
            this.dialog.querySelector('[data-rvs-dialog-img]').alt = z.dataset.name || '';
            this.dialog.querySelector('[data-rvs-dialog-caption]').textContent = z.dataset.name || '';
            this.dialog.showModal();
          } else if (e.target.closest('[data-rvs-dialog-close]') || e.target === this.dialog) {
            this.dialog.close();
          }
        });
        this.ro = 'ResizeObserver' in window ? new ResizeObserver(() => this.update()) : null;
        this.ro && this.ro.observe(this.viewport);
        this.update();
      }

      disconnectedCallback() {
        this.viewport && this.viewport.removeEventListener('scroll', this.onScroll);
        this.ro && this.ro.disconnect();
      }

      step(dir) {
        const card = this.cards[0];
        const w = card ? card.getBoundingClientRect().width + 10 : this.viewport.clientWidth;
        this.viewport.scrollBy({ left: dir * w, behavior: 'smooth' });
      }

      update() {
        const v = this.viewport;
        const max = v.scrollWidth - v.clientWidth;
        const pos = Math.abs(v.scrollLeft);
        if (this.prev) this.prev.hidden = pos < 4;
        if (this.next) this.next.hidden = max < 4 || pos > max - 4;
        if (this.dots.length) {
          const vr = v.getBoundingClientRect();
          let active = 0, best = Infinity;
          this.cards.forEach((c, i) => {
            const d = Math.abs(c.getBoundingClientRect().left - vr.left);
            if (d < best) { best = d; active = i; }
          });
          if (max > 4 && pos > max - 4) active = this.cards.length - 1;
          this.dots.forEach((d, i) => d.classList.toggle('is-active', i === active));
        }
      }
    }
    customElements.define('review-strip', ReviewStrip);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-swipe"] && !Shopify.designMode) return;
  try {
    document.addEventListener(
    'scroll',
    function (event) {
      var track = event.target;
      if (!track || !track.classList || !track.classList.contains('product-card__swipe-track')) return;
      var dots = track.parentElement.querySelectorAll('.product-card__swipe-dot');
      var index = Math.round(track.scrollLeft / (track.clientWidth || 1));
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === index);
      }
    },
    true
  );
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-card-atc]');
    if (!button) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'card_add_to_cart_click',
      product_title: button.getAttribute('data-product-title'),
      variant_id: button.getAttribute('data-variant-id')
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-rating"] && !Shopify.designMode) return;
  try {
    /* Clicking the product rating scrolls to the review list (or any section/id set in Theme settings > Rating). */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-pr-scroll]');
    if (!link || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    var key = String(link.getAttribute('data-pr-scroll') || '').replace(/[^\w-]/g, '');
    if (!key) return;
    var el = document.getElementById(key)
      || document.querySelector('[data-anchor="' + key + '"]')
      || document.querySelector('.shopify-section[id$="__' + key + '"]')
      || document.querySelector('.jdgm-review-widget, .jdgm-rev-widg');
    if (!el) return;
    e.preventDefault();
    for (var n = el; n && n !== document.body; n = n.parentElement) {
      if (n.tagName === 'DETAILS' && !n.open) n.open = true;
    }
    var header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-header-height')) || 0;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var top = el.getBoundingClientRect().top + window.scrollY - header - 12;
    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
    el.focus({ preventScroll: true });
    el.classList.remove('pdpb-flash');
    void el.offsetWidth;
    el.classList.add('pdpb-flash');
    setTimeout(function () { el.classList.remove('pdpb-flash'); }, 2000);
  });
  } catch(e) { console.error(e); }
})();

})();
